export const scrollOffsets = {
  hero: -200,
  about: -150,
  product: -150,
  whiteLabel: -201
};
export const APP_USERS_AMOUNT = 5234456;
